<template>
    <div :class="{'autocomplete-wrapper': true, 'form-group': true, 'row': inline}">
        <label :class="labelClass" :for="name" v-if="label">{{ label }}</label>

        <div :class="{'col-md-8': inline}" class="autocomplete">
            <input
                :class="inputClass"
                :disabled="disabled"
                :id="id"
                :name="name"
                :placeholder="placeholder"
                :type="type"
                :value="value"
                @blur="disableResults"
                @click="autocomplete"
                @input="returnValue"
                @keydown="keyPressed"
                autocomplete="off"
                ref="input"
                v-model="q"
            >

            <ul :class="resultsClass" class="list-group" v-if="showResults" style="min-width:250px">
                <template v-if="hasResults">
                    <li
                        :key="result.id"
                        @click.prevent="select(result)"
                        class="list-group-item result-item"
                        v-for="result in results"
                    >
                        <slot v-bind:result="result">
                            {{ result.name }}
                            <small v-if="result.comment">
                                ({{ result.comment }})
                            </small>
                        </slot>
                    </li>
                </template>

                <template v-else>
                    <li class="list-group-item result-item">{{ __('No results') }}</li>
                </template>
            </ul>

            <div class="invalid-feedback"
                 role="alert"
                 v-if="errors.has(name, scope) && !disableErrorText"
                 v-text="errors.first(name, scope)"
            ></div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'

export default {

  inject: ['$validator'],

  data () {
    return {
      q: null,
      showResults: false,
      results: [],
      selected: false,
      skipWatch: true
    }
  },

  props: {
    disableErrorText: {
      type: Boolean,
      default: false
    },
    scope: {
      type: String,
      default: null
    },
    value: [String, Number, Object],
    type: {
      type: String,
      default: 'text'
    },
    params: {type: Array},
    filterProperty:String,
    label: String,
    name: String,
    fetchCallback: [Function, Array],
    disabled: Boolean,
    placeholder: String,
    valueSelector: String,
    id: String,
    inline: {
      type: Boolean,
      default: false
    },
    data: {
      type: String,
      default: null
    }
  },

  created () {
    this.debouncedSearch = _.debounce(this.autocomplete, 300)
    if (this.data) {
      this.skipWatch = true
      this.q = this.data
    }
  },

  watch: {
    data (value) {
      this.q = value
    }
  },

  computed: {
    hasResults () {
      return this.results.length > 0
    },

    labelClass () {
      return {
        'control-label': true,
        'col-md-4 col-form-label text-md-right': this.inline
      }
    },

    inputClass () {
      return {
        'form-control': true,
        'is-invalid': this.errors.has(this.name, this.scope)
      }
    },

    resultsClass () {
      return {
        'pl-3 pr-3': this.inline
      }
    }
  },

  methods: {
    autocomplete () {
      if (typeof this.fetchCallback == 'function') {
        this.fetchCallback(this.params, this.q ? this.q : '').then((res) => {
       
          this.results = res.data.data ? res.data.data : res.data
          this.showResults = true
         
        })
      } else {
        this.results = this.fetchCallback
        this.showResults = true
      }
    },

    select (result) {
      this.selected = true
      this.$emit('selected', result)
      this.$emit('input', result)
      this.q = _.get(result, this.valueSelector)
      this.$refs.input.focus()

      this.$nextTick(() => {
        this.clear()
      })
    },

    clear () {
      this.results = []
      this.showResults = false
    },

    disableResults () {
      // We need to add a timeout, so that the selection of the result won't bug.
      setTimeout(() => {
        this.showResults = false
      }, 150)
    },

    keyPressed (event) {
      if (event.key === 'Escape' && this.showResults) {
        return this.disableResults()
      }

      if (!this.selected && !this.skipWatch) {
        if (!this.q) {
          this.showResults = false
          return
        }
        this.debouncedSearch()
      }
      this.skipWatch = false
      this.selected = false
    },

    returnValue (event) {
      this.$emit('typed-in-value', event.target.value)
      this.$emit('input', event.target.value)

      if(this.filterProperty){
         this.params[this.filterProperty]=event.target.value

         if(this.params[this.filterProperty]==null ||  this.params[this.filterProperty]=="" ||this.params[this.filterProperty] === undefined){
          delete this.params[this.filterProperty]
         }
      }
     
    },

    resetValue () {
      this.q = ''
    }
  }
}
</script>

<style scoped>
    li.result-item:hover {
        cursor: pointer;
        background: #efefef;
    }

    li.result-item {
        border: 1px solid #6f9afe;
    }

    .autocomplete-wrapper {
        position: relative;
    }

    .list-group {
        position: absolute;
        display: block !important;
        width: 100%;
        z-index: 9999;
        left: 0;
    }
</style>
